import { keepInKeyboardView } from './keyboardViewport.js';

const triggerScrollOnInputFocus = (event, fit = {}) => {
    keepInKeyboardView(event.target, fit);
};

export { triggerScrollOnInputFocus };
//# sourceMappingURL=input.js.map
